import { Button, Modal } from '@skupreme/shared/ui';

/** Asks before a carton alias is deleted. */
export function DeleteAliasModal({
  alias,
  isDeleting,
  onClose,
  onConfirm,
}: {
  /** The alias to delete; none keeps the dialog closed. */
  alias: string | null;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal
      isOpen={!!alias}
      onOpenChange={isOpen => !isOpen && onClose()}
      title="Delete carton alias"
      footer={
        <>
          <Button variant="ghost" onPress={onClose} isDisabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="danger" onPress={onConfirm} isPending={isDeleting}>
            Delete
          </Button>
        </>
      }
    >
      <p className="sk:m-0 sk:text-dense sk:text-fg-secondary">
        Delete the carton alias <b className="sk:text-fg">{alias}</b>? This
        cannot be undone.
      </p>
    </Modal>
  );
}
